import Ukiyo from "ukiyojs";
import $ from "jquery";
document.addEventListener("DOMContentLoaded", init);

const parallaxInstances2 = [];

function init() {
  initParallax2();
}

function initParallax2() {
  const images2 = document.querySelectorAll(".parallax img");
  images2.forEach((image) => {
    const instance = new Ukiyo(image, {
      speed: 2,
      scale: 1.1,
      willChange: true,
    });

    parallaxInstances2.push(instance);
  });
}
